import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import axios from "axios";
import config from "../../config";

const UpdateDiscountModal = ({ open, onClose, discountId }) => {
  const [form, setForm] = useState(null);

  useEffect(() => {
    if (discountId && open) {
      axios.get(`${config.apiBaseUrl}/discounts/${discountId}`).then((res) => {
        const d = res.data;
        setForm({
          ...d,
          startDate: dayjs(d.startDate),
          endDate: dayjs(d.endDate),
        });
      });
    }
  }, [discountId, open]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...form,
        startDate: form.startDate.toISOString(),
        endDate: form.endDate.toISOString(),
        type: "basic",
        conditionJson: "{}",
      };

      await axios.put(`${config.apiBaseUrl}/discounts/${discountId}`, payload);
      onClose();
    } catch (err) {
      alert("Cập nhật thất bại: " + err.response?.data || err.message);
    }
  };

  if (!form) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cập nhật khuyến mãi</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
      >
        <TextField
          label="Product ID"
          value={form.productId || ""}
          onChange={(e) => handleChange("productId", e.target.value)}
          fullWidth
        />
        <TextField
          label="Category ID"
          value={form.categoryId || ""}
          onChange={(e) => handleChange("categoryId", e.target.value)}
          fullWidth
        />
        <TextField
          label="Discount Value"
          type="number"
          value={form.discountValue}
          onChange={(e) => handleChange("discountValue", e.target.value)}
          fullWidth
        />
        <TextField
          label="Discount Type"
          select
          value={form.discountType}
          onChange={(e) => handleChange("discountType", e.target.value)}
          fullWidth
        >
          <MenuItem value="percent">%</MenuItem>
          <MenuItem value="amount">Số tiền</MenuItem>
        </TextField>

        <DateTimePicker
          label="Start Date"
          value={form.startDate}
          onChange={(val) => handleChange("startDate", val)}
        />
        <DateTimePicker
          label="End Date"
          value={form.endDate}
          onChange={(val) => handleChange("endDate", val)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Huỷ</Button>
        <Button onClick={handleSubmit} variant="contained">
          Cập nhật
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateDiscountModal;
